module.exports = __webpack_public_path__ + "img/8_33.480e186a.png";